import React, { useEffect, useState } from 'react';
import { message, Popconfirm, Skeleton, Table } from 'antd';
import EnrollmentTableStatistic from './EnrollmentTableStatistic';
import '../../../style/table.less';
import LocalStorageService from '../../../services/localStorageService';
import tableService from '../../../services/tableService';

const EnrollmentTable = (props) => {
  const {
    isLoading,
    search,
    enrollmentList,
    enrollmentListTotal,
    enrollmentStatistic,
    columns,
    coreColumns,
    isCoreColumns,
    pagination,
    setPagination,
    getQuery,
  } = props;
  const [displayEnrollmentList, setDisplayEnrollmentList] = useState(enrollmentList);

  const handleDelete = async (id) => {
    try {
      await tableService.deleteEnrollment(id);
      message.success('删除成功');
      search(pagination.current, pagination.pageSize, getQuery());
    } catch (err) {
      message.error('删除失败');
    }
  };

  const deleteColumn = {
    title: '操作',
    key: 'operation',
    render: (_, record) => (
      <Popconfirm
        title='确定删除这条报课吗？'
        okText='确定'
        cancelText='取消'
        onConfirm={() => handleDelete(record.key)}
      >
        <a>Delete</a>
      </Popconfirm>
    ),
  };

  const baseColumns = !isCoreColumns ? columns : coreColumns;
  const currentRole = LocalStorageService.getCurrentRole();
  const isAdmin = currentRole === 0 || currentRole === 1;
  const displayColumns = isAdmin
    ? [...baseColumns, deleteColumn]
    : baseColumns;

  useEffect(() => {
    search(pagination.current, pagination.pageSize, getQuery());
  }, [pagination]);

  useEffect(() => {
    let isMounted = true;
    const fillStartDates = async () => {
      const rows = await Promise.all(
        enrollmentList.map(async (row) => {
          if (row.startDate || !row.key) {
            return row;
          }
          try {
            const res = await tableService.searchFeedbacks(row.key);
            const feedbacks = (res.data || [])
              .filter((feedback) => !row.enrollDate || feedback.date >= row.enrollDate)
              .sort((a, b) => String(a.date).localeCompare(String(b.date)));
            return {
              ...row,
              startDate: feedbacks.length ? feedbacks[0].date : '',
            };
          } catch (err) {
            return row;
          }
        })
      );
      if (isMounted) {
        setDisplayEnrollmentList(rows);
      }
    };
    fillStartDates();
    return () => {
      isMounted = false;
    };
  }, [enrollmentList]);

  const handleTableChange = ({ current, pageSize, total }) => {
    console.log('pagination', pagination);
    setPagination({ current, pageSize });
  };
  return isLoading ? (
    <Skeleton active />
  ) : (
    <Table
      dataSource={displayEnrollmentList}
      columns={displayColumns}
      pagination={{
        ...pagination,
        total: enrollmentListTotal,
        position: ['topLeft'],
      }}
      onChange={handleTableChange}
      summary={(pageData) => {
        // console.log('pageData: ', pageData);
        const totalEnrollPrice = enrollmentStatistic.totalEnrollPrice;
        const totalBalance = enrollmentStatistic.totalBalance;

        return LocalStorageService.getCurrentRole() === 2 ? null : (
          <EnrollmentTableStatistic
            totalEnrollPrice={totalEnrollPrice}
            totalBalance={totalBalance}
          />
        );
      }}
    />
  );
};

export default EnrollmentTable;
